if (!customElements.get("lsg-video-grid")) {
    customElements.define("lsg-video-grid", class LSGVideoGrid extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                modalToggle: ".js-lsg-video-grid-modal-toggle"
            };
            this.modalToggle = this.querySelectorAll(this.selectors.modalToggle);
            this.init();
        }

        init() {
            this.modalToggle.forEach(el => {
                el.addEventListener("click", () => {
                    this.loadContent();
                })
            })
        }

        loadContent(focus = true) {
            document.querySelectorAll('video').forEach((video) => video.pause());

            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
            var mq = window.matchMedia("(max-width: 767px)");
            if(mq.matches){
                content.querySelector(".lsg-video-grid__video-media--desk")?.remove();
            }else{
                content.querySelector(".lsg-video-grid__video-media--mob")?.remove();
            }
            const modal = document.querySelector("body").appendChild(content.querySelector('lsg-modal-dialog'));
            const deferredElement = modal.querySelector("video");
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
            modal?.openModal();

        }
    })
}
if (!customElements.get("lsg-video-grid-gallery")) {
    customElements.define("lsg-video-grid-gallery", class LSGVideoGrid extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init() {
            if (!this.classList.contains("lsg-video-grid__grid--1")) {

                new window.Flickity(this, {
                    watchCSS: true,
                    prevNextButtons: false,
                    // draggable: false
                });
            }

        }
    })
}
